export default () => ({
  tasks: [],
  data: [],
  meta: {},
  isLoading: false,
  hasError: false,
});
